if (typeof globalThis.Buffer === 'undefined') {
  const { Buffer: NodeBuffer } = await import('buffer');
  if (typeof globalThis.Buffer === 'undefined') {
    globalThis.Buffer = NodeBuffer;
  }
}

export {};
